var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ribbonText)?_c('corner-ribbon',{attrs:{"text":_vm.ribbonText}}):_vm._e(),_c('pno-navigation'),_c('div',{attrs:{"id":"main"}},[_c('app-view',{key:_vm.$route.fullPath})],1),_c('pno-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }